import {Brand, Garage, Organization, Service} from "@App/types";
import {
    GarageHasNationwideService,
    GarageHasPhone,
    GarageIsBookable,
    GarageIsDrivinLicenseCheckpoint
} from "@App/utils/conditionals/garages";
import {
    OrganizationIsAkf,
    OrganizationIsAkfLangzeitmiete,
    OrganizationIsArval,
    OrganizationIsAthlon,
    OrganizationIsDBConnect,
    OrganizationIsDeutscheLeasing,
    OrganizationIsFinn,
    OrganizationIsFleethub,
    OrganizationIsLeaseplan,
    OrganizationIsMeinAuto,
    OrganizationIsMobilityConcept,
    OrganizationIsNio,
    OrganizationIsRepareo
} from "@App/utils/conditionals/organization";
import {
    ServiceIsAppointment,
    ServiceIsAutoAbo,
    ServiceIsCertificate,
    ServiceIsEVehicleAppointment,
    ServiceIsGaragesNearby,
    ServiceIsGlass,
    ServiceIsInspection,
    ServiceIsTireStorage,
    ServiceIsVehicleReturn,
    ServiceIsWheelChange,
    ServiceIsWheelChangeTiresStored,
    ServiceIsWheelReplacement
} from "@App/utils/conditionals/services";
import {BrandIsMG, BrandIsTesla} from "@App/utils/conditionals/brands";
import {FuelTypeAyvens} from "@App/types/enums";


export const GarageIsBookableOnArval = (organization: Organization, garage: Garage) => {
    return (GarageIsBookable(garage) && OrganizationIsArval(organization))
}


export const OrganizationIsRepareoAndServiceIsNotCertificate = (organization: Organization, service: Service) => {
    return (!ServiceIsCertificate(service) && OrganizationIsRepareo(organization))
}

export const ServiceIsInspectionOrServiceIsAppointment = (service: Service) => {
    return (ServiceIsInspection(service) || ServiceIsAppointment(service))
}


export const ServiceIsInspectionOrServiceIsEVehicleAppointment = (service: Service) => {
    return (ServiceIsInspection(service) || ServiceIsEVehicleAppointment(service))
}


export const ServiceIsAppointmentOrInspectionOrServiceIsEVehicleAppointment = (service: Service) => {
    return (ServiceIsAppointment(service) || ServiceIsInspection(service) || ServiceIsEVehicleAppointment(service))
}


export const ServiceIsInspectionOrServiceIsAppointmentOrServiceIsEVehicleAppointment = (service: Service) => {
    return (ServiceIsInspection(service) || ServiceIsAppointment(service) || ServiceIsEVehicleAppointment(service))
}

export const OrganizationIsNeitherRepareoNorDBConnect = (organization: Organization) => {
    return (!OrganizationIsDBConnect(organization) && !OrganizationIsRepareo(organization))
}

export const OrganizationIsNeitherRepareoNorDBConnectNorLeaseplan = (organization: Organization) => {
    return (!OrganizationIsDBConnect(organization) && !OrganizationIsRepareo(organization) && !OrganizationIsLeaseplan(organization))
}

export const OrganizationIsRepareoAndServiceIsInspection = (organization: Organization, service: Service) => {
    return (ServiceIsInspection(service) && OrganizationIsRepareo(organization))
}

export const OrganizationIsLeaseplanAndServiceIsAppointment = (organization: Organization, service: Service) => {
    return ((ServiceIsAppointment(service) || ServiceIsEVehicleAppointment(service)) && OrganizationIsLeaseplan(organization))
}


export const OrganizationIsLeaseplanAndServiceIsInspection = (organization: Organization, service: Service) => {
    return (ServiceIsInspection(service) && OrganizationIsLeaseplan(organization))
}

export const OrganizationIsLeaseplanAndServiceIsNotAppointment = (organization: Organization, service: Service) => {
    return (!ServiceIsAppointment(service) && OrganizationIsLeaseplan(organization))
}

export const ServiceIsGlassAndGarageHasNationwideService = (service: Service, garage: Garage) => {
    return (ServiceIsGlass(service) && GarageHasNationwideService(garage))
}

export const ServiceIsVehicleReturnAndGarageIsDrivinLicenseCheckpoint = (service: Service, garage: Garage) => {
    return (ServiceIsVehicleReturn(service) && GarageIsDrivinLicenseCheckpoint(garage))
}

export const OrganizationIsLeaseplanAndServiceIsGaragesnearby = (organization: Organization, service: Service) => {
    return (ServiceIsGaragesNearby(service) && OrganizationIsLeaseplan(organization))
}

export const OrganizationIsNotDBConnectAndServiceIsVehicleReturn = (organization: Organization, service: Service) => {
    return (ServiceIsVehicleReturn(service) && !OrganizationIsDBConnect(organization))
}

export const GarageIsNotBookableAndHasPhone = (garage: Garage) => {
    return (!GarageIsBookable(garage) && GarageHasPhone(garage))
}

export const OrganizationIsArvalAndServiceIsWheelChange = (organization: Organization, service: Service) => {
    return (ServiceIsWheelChange(service) && OrganizationIsArval(organization))
}

export const OrganizationIsNotArvalOrServiceIsNotWheelChange = (organization: Organization, service: Service) => {
    return (!ServiceIsWheelChange(service) || !OrganizationIsArval(organization))
}

export const OrganizationIsLeasePlanAndServiceIsNotWheelchangeAndServiceIsNotGlass = (organization: Organization, service: Service) => {
    return (!ServiceIsWheelChange(service) && !ServiceIsGlass(service) && OrganizationIsLeaseplan(organization))
}


export const OrganizationIsLeasplanOrDBConnect = (organization: Organization) => {
    return (OrganizationIsDBConnect(organization) || OrganizationIsLeaseplan(organization))
}


export const OrganizationIsArvalOrMobilityConcept = (organization: Organization) => {
    return (OrganizationIsArval(organization) || OrganizationIsMobilityConcept(organization))
}

export const BrandIsMGOrBrandIsTesla = (brand: Brand) => {
    return (BrandIsMG(brand) || BrandIsTesla(brand))
}


export const BrandIsMGOnServiceInspection = (brand: Brand, service: Service) => {
    return (BrandIsMG(brand) && ServiceIsInspectionOrServiceIsEVehicleAppointment(service))
}


export const BrandIsMGOnServiceInspectionAndCombustionEngine = (brand: Brand, service: Service, bev: boolean) => {
    return (BrandIsMG(brand) && ServiceIsInspectionOrServiceIsEVehicleAppointment(service) && bev == false)
}


export const ShouldShowChooseDifferentCriteriaHintStep = (brand: Brand, service: Service, bev: boolean) => {
    return (BrandIsMG(brand) && ServiceIsAppointmentOrInspectionOrServiceIsEVehicleAppointment(service) && bev == true)
}

export const ServiceIsWheelChangeOrServieIsAutoAbo = (service: Service) => {
    return (ServiceIsWheelChange(service) || ServiceIsAutoAbo(service))
}

export const ServiceIsWheelChangeOrServieIsWheelChangeTiresstored = (service: Service) => {
    return (ServiceIsWheelChange(service) || ServiceIsWheelChangeTiresStored(service))
}

export const ServiceIsWheelChangeOrServiceIsAutoAboOrServiceIsWheelChangeTiresstored = (service: Service) => {
    return (ServiceIsWheelChange(service) || ServiceIsAutoAbo(service) || ServiceIsWheelChangeTiresStored(service) || ServiceIsTireStorage(service))
}

export const OrganizationIsMobilityConceptAndServiceIsAutoAbo = (organization: Organization, service: Service) => {
    return (OrganizationIsMobilityConcept(organization) && ServiceIsAutoAbo(service))
}

export const OrganizationIsLeaseplanAndServiceServiceIsEVehicleAppointment = (organization: Organization, service: Service) => {
    return (OrganizationIsLeaseplan(organization) && ServiceIsEVehicleAppointment(service))
}



export const OrganizationHasSelectableBevSupport =  (organization: Organization) => {
    return (OrganizationIsLeaseplan(organization) || OrganizationIsArval(organization) || OrganizationIsFinn(organization))
}

export const ServiceShouldDisplayBevOnCurrentList = (service: Service, organization: Organization) => {
    return ((!ServiceIsGlass(service) && OrganizationIsLeaseplan(organization)) || OrganizationIsFinn(organization) || (OrganizationIsArval(organization) && ServiceIsInspection(service)))
}


export const OrganizationIsNotAkfAndNotAkfLangzeitmiete =  (organization: Organization) => {
    return (!OrganizationIsAkf(organization) && !OrganizationIsAkfLangzeitmiete(organization))
}

export const ServiceIsWheelChangeAndOrganizationIsNio = (organization: Organization, service: Service) => {
    return (OrganizationIsNio(organization) && ServiceIsWheelChange(service))
}

export const ServiceIsWheelReplacementAndOrganizationIsNio = (organization: Organization, service: Service) => {
    return (OrganizationIsNio(organization) && ServiceIsWheelReplacement(service))
}

export const ServiceIsWheelChangeTiresstoredAndOrganizationIsNio = (organization: Organization, service: Service) => {
    return (OrganizationIsNio(organization) && ServiceIsWheelChangeTiresStored(service))
}


export const ServiceIsWheelChangeAndOrganizationIsMeinAuto = (organization: Organization, service: Service) => {
    return (OrganizationIsMeinAuto(organization) && ServiceIsWheelChange(service))
}

export const ServiceIsWheelReplacementAndOrganizationIsMeinAuto = (organization: Organization, service: Service) => {
    return (OrganizationIsMeinAuto(organization) && ServiceIsWheelReplacement(service))
}

export const ServiceIsWheelRelatedAndOrganizationIsMeinAuto = (organization: Organization, service: Service) => {
    return (OrganizationIsMeinAuto(organization) && (ServiceIsWheelReplacement(service) || ServiceIsWheelChange(service) || ServiceIsWheelChangeTiresStored(service)))
}

export const ServiceIsWheelRelatedAndOrganizationIsMobilityConcept = (organization: Organization, service: Service) => {
    return (OrganizationIsMobilityConcept(organization) && (ServiceIsWheelReplacement(service) || ServiceIsWheelChange(service) || ServiceIsWheelChangeTiresStored(service)))
}

export const ServiceIsWheelReplacementAndOrganizationIsMobilityConcept = (organization: Organization, service: Service) => {
    return (OrganizationIsMobilityConcept(organization) && ServiceIsWheelReplacement(service))
}

export const OrganizationShouldDisplayAsNonBookableForTires =  (organization: Organization) => {
    return (OrganizationIsAkf(organization) || OrganizationIsAkfLangzeitmiete(organization) || OrganizationIsDeutscheLeasing(organization) ||OrganizationIsArval(organization) || OrganizationIsDBConnect(organization) || OrganizationIsFleethub(organization) || OrganizationIsAthlon(organization))
}

export const fuelTypeIsBevForAyvens =  (id: Number) => {
    return (id === FuelTypeAyvens.BENZINELEKTRO || id === FuelTypeAyvens.DIESELELEKTRO || id === FuelTypeAyvens.ELEKTRO || id === FuelTypeAyvens.WASSERSTOFF || id === FuelTypeAyvens.BENZINETHANOLELEKTRO)
}

